import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const PORTFOLIO = [
  {
    client: 'Operations workflow',
    project: 'Business systems with actual daily usage',
    desc: 'Dashboards, booking flows, and admin panels designed for owners who need clarity, not clutter.',
    tags: ['Web App', 'Dashboard', 'Automation'],
    result: 'Built to reduce manual follow-up and reporting time.',
    accent: '#56BAF7',
    accentSoft: 'rgba(86,186,247,0.35)',
    accentFaint: 'rgba(86,186,247,0.14)',
  },
  {
    client: 'Brand-led storefronts',
    project: 'Premium landing pages that convert',
    desc: 'Tighter copy, calmer typography, better section rhythm, and richer interactions on every device.',
    tags: ['Branding', 'Landing Page', 'UX'],
    result: 'Designed to feel trustworthy in the first few seconds.',
    accent: '#E59F54',
    accentSoft: 'rgba(229,159,84,0.35)',
    accentFaint: 'rgba(229,159,84,0.14)',
  },
  {
    client: 'Growth engines',
    project: 'AI, ads, and lead capture in one stack',
    desc: 'Marketing automation, WhatsApp workflows, and always-on lead routing connected into one system.',
    tags: ['AI', 'CRM', 'Performance'],
    result: 'Made for teams that want fewer tools and more momentum.',
    accent: '#8FD6A7',
    accentSoft: 'rgba(143,214,167,0.35)',
    accentFaint: 'rgba(143,214,167,0.14)',
  },
];

export default function Portfolio() {
  const ref = useRef(null);

  useEffect(() => {
    gsap.from(ref.current.querySelector('.port-head'), {
      opacity: 0, y: 30, duration: 0.7, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 80%' },
    });
    gsap.from(ref.current.querySelectorAll('.port-card'), {
      opacity: 0, y: 50, stagger: 0.14, duration: 0.7, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 70%' },
    });

    // Ensures ScrollTrigger calculates correct positions after mount.
    ScrollTrigger.refresh();
  }, []);

  return (
    <section id="work" ref={ref} className="section">
      <div className="container">
        <div className="section-heading port-head">
          <p className="eyebrow">Case Studies</p>
          <h2 className="heading">
            Designed for businesses that need
            <span className="gradient-text"> clarity, speed, and trust.</span>
          </h2>
        </div>

        <div className="cards-grid">
          {PORTFOLIO.map((p) => (
            <div
              key={p.project}
              className="card portfolio-card port-card"
              style={{
                '--accent': p.accent,
                '--accent-soft': p.accentSoft,
                '--accent-faint': p.accentFaint,
              }}
            >
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginBottom: 18 }}>
                {p.tags.map((t) => (
                  <span key={t} className="tag">
                    {t}
                  </span>
                ))}
              </div>

              <div className="eyebrow" style={{ color: 'var(--text-muted)' }}>
                {p.client}
              </div>
              <h3>{p.project}</h3>
              <p>{p.desc}</p>
              <div className="portfolio-result"> {p.result}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
